import React from "react";

import "./WordColumn.css";

import WordCard from "../WordCard";

const WordColumn = (props) => {
  const { columnIndex, isLive, words, selected, incorrect, correct, correctGuess } = props;
  const className = `word-column ${words.length ? "" : "empty"}`;
  return (
    <div className={className}>
      {words.map((word, i) => (
        <WordCard
          key={i}
          isLive={isLive}
          correct={correct}
          correctGuess={correctGuess}
          incorrect={incorrect}
          columnIndex={columnIndex}
          word={word}
          wordIndex={i}
          isSelected={selected === i}
        />
      ))}
    </div>
  );
};

export default WordColumn;
